import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { FC, useCallback, useEffect } from 'react';
import DropDownWithSearch from 'src/components/DropDownWithSearch';
import usePeriodView from 'src/hooks/usePeriodView';
import { FiscalAllYearsResponse } from 'src/services/useAllGetFiscalYearsApi';
import { ManagementCompanyObject } from 'src/services/useGetManagementCompanyApi';
import { SetState } from 'src/types/generic';
import { PropertyObject } from './Export';

interface ManagementCompanyDropdownProps {
  managementCompany: ManagementCompanyObject;
  setManagementCompany: SetState<ManagementCompanyObject>;
  data: ManagementCompanyObject[];
  loading: boolean;
  setProperty: SetState<PropertyObject>;
  properties: FiscalAllYearsResponse[];
}

const ManagementCompanyDropdown: FC<ManagementCompanyDropdownProps> = ({
  managementCompany,
  setManagementCompany,
  data,
  loading,
  setProperty,
  properties,
}) => {
  const { t } = usePeriodView();
  const handleManagementCompanyChange = useCallback(
    (event: DropDownListChangeEvent) => {
      setManagementCompany(event.value);
      setProperty({} as PropertyObject);
    },
    [setManagementCompany, setProperty]
  );

  useEffect(() => {
    if (properties.length > 0 && managementCompany) {
      setProperty(properties[0]);
    }
  }, [managementCompany, properties, setProperty]);

  return (
    <div className="mb-2">
      <label className="text-xs font-bold">{t('Management Company')}</label>
      <DropDownWithSearch
        id="view-drop-down-list"
        style={{ width: '100%' }}
        options={data}
        textField="companyName"
        dataItemKey="companyId"
        value={managementCompany}
        onChange={handleManagementCompanyChange}
        disabled={loading}
        loading={loading}
      />
    </div>
  );
};

export default ManagementCompanyDropdown;
